import { useState } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Form } from '@/components/ui/form';
import * as z from 'zod';

import Textarea from '@/components/form/Textarea';
import { Button } from '@/components/ui/button';
import { usePutBooking } from '@/data/booking';

const formSchema = z.object({
  coachNotes: z.string().optional()
});

const EditNoteForm = ({ booking, setIsEditingNote, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const putBooking = usePutBooking();
  //   const booking = useBooking(bookingId);

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      coachNotes: booking.coachNotes
    }
  });

  const onSubmit = async (values) => {
    try {
      setSubmitting(true);
      await putBooking(booking.id, values);
      //   booking.mutate(updatedBooking, false);
      await onSuccess();
      setSubmitting(false);
      setIsEditingNote(false);
    } catch (err) {
      setSubmitting(false);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Textarea name="coachNotes" label="Notes" height={125} />
        <div className="flex justify-end mt-4">
          <Button loading={submitting} variant="outline" size="sm">
            Save
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default EditNoteForm;
